import { useRef } from 'react'
import { chooseTickIntervalSec, secToPx } from '../../../lib/timelineMath'
import { RULER_H } from './constants'

/** task spec §2-1: ラベルは "SS.s" 表記（時分では区切らない、秒のみ小数第1位）。 */
function formatTick(sec: number): string {
  return sec.toFixed(1)
}

export function Ruler({
  totalSec,
  pxPerSec,
  onScrub,
}: {
  totalSec: number
  pxPerSec: number
  onScrub: (clientX: number) => void
}) {
  const dragging = useRef(false)
  const seconds = Math.ceil(totalSec) + 5
  const interval = chooseTickIntervalSec(pxPerSec)
  const tickCount = Math.floor(seconds / interval) + 1
  // ズームが荒い間隔(>=0.5s)ならティックごとにラベル、細かい間隔ではラベルを
  // 概ね1秒おきに間引く（frame刻みで30個ずつラベルが並ぶのを防ぐ）。
  const labelEveryNTicks = interval >= 0.5 ? 1 : Math.max(1, Math.round(1 / interval))

  return (
    <div
      className="relative border-b border-ink-border/60 select-none cursor-pointer"
      style={{ height: RULER_H, width: seconds * pxPerSec }}
      data-testid="ruler"
      onPointerDown={(e) => {
        dragging.current = true
        ;(e.target as HTMLElement).setPointerCapture(e.pointerId)
        onScrub(e.clientX)
      }}
      onPointerMove={(e) => {
        if (dragging.current) onScrub(e.clientX)
      }}
      onPointerUp={(e) => {
        dragging.current = false
        ;(e.target as HTMLElement).releasePointerCapture(e.pointerId)
      }}
    >
      {Array.from({ length: tickCount }, (_, i) => i).map((i) => {
        const s = i * interval
        const isMajor = i % labelEveryNTicks === 0
        return (
          <div key={i} className="absolute top-0 bottom-0" style={{ left: secToPx(s, pxPerSec) }}>
            <div className={`w-px bg-ink-border ${isMajor ? 'h-3' : 'h-1.5'}`} />
            {isMajor && (
              <span className="absolute top-3 -left-1 text-[9px] text-text-faint tabular-nums">
                {formatTick(s)}
              </span>
            )}
          </div>
        )
      })}
    </div>
  )
}
